import { useEffect, useState } from 'react';
import { Video } from '../../../types/Video';
import { twMerge } from 'tailwind-merge';
import { getImageDimensions } from '@lib/images/getImageDimensions';
import { logger } from '@lib/logger/logger';

interface PostVideoProps {
  video: Video;
  className?: string;
}

export const PostVideo = ({ video, className }: PostVideoProps) => {
  const [videoDirection, setVideoDirection] = useState<'portrait' | 'landscape'>('portrait');

  useEffect(() => {
    const fetchDimensions = async () => {
      const dimensions = await getImageDimensions(video.screenshot.url);
      if (dimensions.width > dimensions.height) {
        setVideoDirection('landscape');
      } else {
        setVideoDirection('portrait');
      }
    };
    fetchDimensions().catch((error: unknown) =>
      logger.error('Failed to fetch video dimensions:', error),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section
      className={twMerge(
        `relative flex w-full snap-center justify-center ${videoDirection === 'portrait' ? 'w-[85%]' : 'w-full'}`,
        className,
      )}
    >
      <video
        className={`absolute inset-0 size-full ${videoDirection === 'portrait' ? 'object-cover' : 'object-contain'}`}
        width="100%"
        style={{ height: '100%' }}
        controls
        poster={video.screenshot.url ? video.screenshot.url : ''}
        preload="none"
      >
        {video.hlsUrl && <source src={video.hlsUrl} type="application/x-mpegURL" />}
        {video.webUrl && <source src={video.webUrl} type="video/mp4" />}
        {video.originalUrl && <source src={video.originalUrl} type="video/mp4" />}
      </video>
    </section>
  );
};
